import { TextIcon } from '@europrocurement/flexy-components';
import { tarifFrance } from '@europrocurement/l2d-utils';
import { Checkbox, Typography, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import PanierElementDateToChip from '../PanierElementDateToChip/PanierElementDateToChip';

export type PanierReglementSelectedElementProps = {
    title: string;
    subtitle?: string;
    onChange: (checked: boolean) => void;
    checked: boolean;
    selectionnables: boolean;
    disabled: boolean;
    dateCreation?: string;
    dateEcheance?: string;
    ttcRestant: string;
    type?: 'recouvrement' | 'paiement';
};

const PanierReglementSelectedElement: React.FunctionComponent<PanierReglementSelectedElementProps> =
    function (props) {
        const {
            onChange,
            checked,
            disabled,
            selectionnables,
            title,
            subtitle,
            dateCreation,
            dateEcheance,
            ttcRestant,
            type = 'paiement',
        } = props;

        const { palette } = useTheme();

        let selectBoxWidth = '0px';
        if (selectionnables) {
            selectBoxWidth = '40px';
        }

        let color = palette.grey[500];
        if ((ttcRestant as unknown as number) === 0) {
            color = palette.success.main;
        } else if (checked) {
            color = palette.primary.main;
        }

        const infoBoxWidth = `calc(100% - ${selectBoxWidth} )`;
        return (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    padding: '10px 15px 10px 10px',
                    gap: '5px',
                    borderRadius: '16px',
                    alignItems: 'flex-start',
                    border: `1px solid ${color}`,
                }}
            >
                {selectionnables && (ttcRestant as unknown as number) !== 0 ? (
                    <Box sx={{ width: selectBoxWidth }}>
                        <Checkbox
                            color="primary"
                            disabled={disabled}
                            onChange={(e) => {
                                onChange(e.target.checked);
                            }}
                            checked={disabled ? false : checked}
                        />
                    </Box>
                ) : null}
                {selectionnables && (ttcRestant as unknown as number) === 0 ? (
                    <Box
                        sx={{
                            width: selectBoxWidth,
                        }}
                    />
                ) : null}

                <Box
                    sx={{
                        width: infoBoxWidth,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '5px',
                        paddingTop: '5px',
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: '5px',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                        }}
                    >
                        <Typography
                            variant="l2dbodym"
                            sx={{ fontWeight: 600 }}
                        >
                            {title}
                        </Typography>

                        <PanierElementDateToChip
                            type={type}
                            ttcRestant={ttcRestant}
                            dateEcheance={dateEcheance}
                        />
                    </Box>

                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: '5px',
                            alignItems: 'flex-end',
                            justifyContent: 'space-between',
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '5px',
                            }}
                        >
                            <Typography variant="l2dlabel">{subtitle}</Typography>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: {
                                        xs: 'column',
                                        sm: 'column',
                                        md: 'row',
                                        lg: 'row',
                                        xl: 'row',
                                    },
                                    gap: '5px',
                                }}
                            >
                                {dateCreation && (
                                    <TextIcon
                                        gap="8px"
                                        icon={{ props: { icon: ['fasl', 'calendar'] } }}
                                        typoProps={{ variant: 'body2' }}
                                    >
                                        Émise : {new Date(dateCreation).toLocaleDateString()}
                                    </TextIcon>
                                )}
                                {dateEcheance && (
                                    <TextIcon
                                        gap="8px"
                                        icon={{ props: { icon: ['fasl', 'calendar'] } }}
                                        typoProps={{ variant: 'body2' }}
                                    >
                                        Échéance : {new Date(dateEcheance).toLocaleDateString()}
                                    </TextIcon>
                                )}
                            </Box>
                        </Box>
                        <Typography
                            sx={{
                                textAlign: 'right',
                                fontWeight: '800',
                            }}
                            variant="h4"
                        >
                            {ttcRestant !== 0 && tarifFrance(ttcRestant as unknown as number)}
                        </Typography>
                    </Box>
                </Box>
            </Box>
        );
    };

export default PanierReglementSelectedElement;
